"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Search = _interopRequireDefault(require("@quintoandar/cozy-icons/Search"));
var _Tune = _interopRequireDefault(require("@quintoandar/cozy-icons/Tune"));
var _CloseFilled = _interopRequireDefault(require("@quintoandar/cozy-icons/CloseFilled"));
var _useFormState2 = _interopRequireDefault(require("../../../Form/hooks/useFormState"));
var _IconButton = _interopRequireDefault(require("../../../IconButton"));
var Styled = _interopRequireWildcard(require("./SearchBarInput.styles"));
var _SearchBarInput2 = require("./SearchBarInput.types");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var EMPTY_STRING = '';
var SearchBarInput = function SearchBarInput(_ref) {
  var onFilter = _ref.onFilter,
    onReset = _ref.onReset,
    onSearch = _ref.onSearch,
    onSearchSuccess = _ref.onSearchSuccess,
    onSearchError = _ref.onSearchError,
    decorativeSearchIcon = _ref.decorativeSearchIcon,
    initialValue = _ref.initialValue,
    placeholder = _ref.placeholder,
    size = _ref.size,
    trigger = _ref.trigger;
  var _useFormState = (0, _useFormState2["default"])(),
    watch = _useFormState.watch,
    setValue = _useFormState.setValue;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    timeoutId = _useState2[0],
    setTimeoutId = _useState2[1];
  var inputValue = watch('search');
  var submitFormManually = function submitFormManually(value) {
    Promise.resolve(onSearch({
      search: value
    })).then(onSearchSuccess)["catch"](onSearchError);
  };
  (0, _react.useEffect)(function () {
    if (trigger === _SearchBarInput2.Trigger.ON_TYPE && inputValue !== undefined) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      var id = setTimeout(function () {
        return submitFormManually(inputValue);
      }, 500);
      setTimeoutId(id);
    }
  }, [inputValue]);
  var cleanSearch = function cleanSearch() {
    setValue('search', EMPTY_STRING);
    if (trigger === _SearchBarInput2.Trigger.ON_SUBMIT) {
      // when trigger === Trigger.ON_TYPE, onSearch will be called automatically
      submitFormManually(EMPTY_STRING);
    }
    onReset();
  };
  var renderStartAdorment = function renderStartAdorment() {
    if (decorativeSearchIcon) return /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
      icon: _Search["default"],
      type: "submit",
      disabled: true
    });
    return null;
  };
  var renderEndAdorment = function renderEndAdorment() {
    if (onFilter) return /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
      icon: _Tune["default"],
      onClick: onFilter
    });
    if (decorativeSearchIcon) return null;
    if (typeof inputValue === 'string' && inputValue !== '') return /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
      icon: _CloseFilled["default"],
      type: "reset",
      onClick: cleanSearch
    });
    return /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
      icon: _Search["default"],
      type: "submit"
    });
  };
  return /*#__PURE__*/_react["default"].createElement(Styled.Input, {
    name: "search",
    id: "search",
    placeholder: placeholder,
    initialValue: initialValue,
    startAdornment: renderStartAdorment(),
    endAdornment: renderEndAdorment(),
    size: size
  });
};
var _default = exports["default"] = SearchBarInput;